function getProtocol(url) {
    let protocol = '';
    try {
        protocol = new URL(url).protocol;
    }
    catch { }
    return protocol;
}
export function isForbidden(url) {
    const protocol = getProtocol(url);
    return ['javascript:'].includes(protocol);
}
export const getValidLink = (rawUrl) => {
    const url = rawUrl.trim();
    if (!url) {
        return null;
    }
    if (/^(\/|#)/.test(url)) {
        return url;
    }
    if (isForbidden(url)) {
        return null;
    }
    const protocol = getProtocol(url);
    if (protocol === 'mailto:') {
        // mailto 校验必须有 x@x 的形状
        return /mailto:.+@./i.test(url) ? url : null;
    }
    if (protocol) {
        return url;
    }
    return /\w/.test(url) ? `http://${url}` : null;
};
//# sourceMappingURL=utils.js.map